import NativeClient from "@/client/native-client";

export default class DateUtil {
  static getDateJST(utcString: string) {
    const utcDate = new Date(utcString);
    const options = { timeZone: 'Asia/Tokyo' };
    const jstString = utcDate.toLocaleString('ja-JP', options);
    NativeClient.sendDebugLog("getDateJST utcString=" + utcString + " jstString=" + jstString);
    const jstDate = new Date(jstString);
    return jstDate;
  }

  static formatMMDD(dateString: string) {
    let result = "";
    if (dateString != "") {
      const time = Date.parse(dateString);
      const date = new Date(time);
      const m = ("00" + (date.getMonth()+1)).slice(-2);
      const d = ("00" + (date.getDate())).slice(-2);
      result = m + "/" + d;
    }
    return result;
  }
  static formatYYMMDD(dateString: string) {
    let result = "";
    if (dateString != "") {
      const time = Date.parse(dateString);
      const date = new Date(time);
      const y = ("" + date.getFullYear()).slice(-2);
      const m = ("00" + (date.getMonth()+1)).slice(-2);
      const d = ("00" + (date.getDate())).slice(-2);
      result = y + "/" + m + "/" + d;
    }
    return result;
  }

  static dateYYYYMMDD_hhmm(date: Date) {
    const y = ("" + date.getFullYear());
    const m = ("00" + (date.getMonth()+1)).slice(-2);
    const d = ("00" + (date.getDate())).slice(-2);
    const h = ("00" + (date.getHours())).slice(-2);
    const min = ("00" + (date.getMinutes())).slice(-2);
    const result = y + "/" + m + "/" + d + " " + h + ":" + min;
    return result;
  }

  static formatYYYYMMDD_hhmm(dateString: string) {
    let result = "";
    if (dateString != "") {
      const time = Date.parse(dateString);
      const date = new Date(time);
      result = DateUtil.dateYYYYMMDD_hhmm(date);
    }
    return result;
  }

  static formatYYYYMMDD_hhmm_JST(dateString: string) {
    let result = "";
    if (dateString != "") {
      const date = DateUtil.getDateJST(dateString);
      result = DateUtil.dateYYYYMMDD_hhmm(date);
    }
    return result;
  }

  static dateYYYYMMDD(date: Date) {
    const y = ("" + date.getFullYear());
    const m = ("00" + (date.getMonth()+1)).slice(-2);
    const d = ("00" + (date.getDate())).slice(-2);
    const result = y + "/" + m + "/" + d;
    return result;
  }
  static dateYYYYMMDDWithHiphen(date: Date) {
    const y = ("" + date.getFullYear());
    const m = ("00" + (date.getMonth()+1)).slice(-2);
    const d = ("00" + (date.getDate())).slice(-2);
    const result = y + "-" + m + "-" + d;
    return result;
  }

  static dateYYYYMMWithHiphen(date: Date) {
    const y = ("" + date.getFullYear());
    const m = ("00" + (date.getMonth()+1)).slice(-2);
    const result = y + "-" + m;
    return result;
  }

  static formatYYYYMMDD(dateString: string) {
    let result = "";
    if (dateString != "") {
      const time = Date.parse(dateString);
      const date = new Date(time);
      result = DateUtil.dateYYYYMMDD(date);
    }
    return result;
  }

  static formatYYYYMMDD_JST(dateString: string) {
    let result = "";
    if (dateString != "") {
      const date = DateUtil.getDateJST(dateString);
      result = DateUtil.dateYYYYMMDD(date);
    }
    return result;
  }

  static formatYYYMMDD(date: Date) {
    const y = ("" + date.getFullYear());
    const m = ("00" + (date.getMonth()+1)).slice(-2);
    const d = ("00" + (date.getDate())).slice(-2);
    const result = y + "-" + m + "-" + d;
    return result;
  }

  static getToday() {
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const result = DateUtil.formatYYYMMDD(date);
    return result;
  }
  static getDayCal(fromString: string | null, toString: string | null) {
    let day = 0;
    if (toString != null && fromString != null) {
      const from = new Date(fromString);
      const to = new Date(toString);
      NativeClient.sendDebugLog("getDayCal from=" + JSON.stringify(from));
      NativeClient.sendDebugLog("getDayCal to=" + JSON.stringify(to));
      // 日数の計算  86,400,000ミリ秒＝1日（1000ミリ秒×60秒×60分×24時間×365日）
      const fromTime = from.getTime();
      const toTime = to.getTime();
      NativeClient.sendDebugLog("getDayCal fromTime=" + fromTime);
      NativeClient.sendDebugLog("getDayCal toTime=" + toTime);
      const termDay = ((toTime - fromTime) / 86400000);
      day = Math.floor(termDay);
    }
    NativeClient.sendDebugLog("getDayCal day=" + day);
    return day;
  }

  static addDay(dateString: string, day: number) {
    const date = new Date(dateString);
    date.setDate(date.getDate() + day);
    const result = DateUtil.formatYYYMMDD(date);
    return result;
  }

  static subtractionDay(dateString: string, day: number) {
    const date = new Date(dateString);
    date.setDate(date.getDate() - day);
    const result = DateUtil.formatYYYMMDD(date);
    return result;
  }

  static getDateMs(dateString: string) {
    const date = new Date(dateString);
    const dateMs = date.getTime();
    return dateMs;
  }

  static getTodayMs() {
    const date = new Date();
    const dateMs = date.getTime();
    return dateMs;
  }

  static getFormattedDateWithTimezone(utc: string) {
    const date = new Date(utc);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const timezoneOffset = date.getTimezoneOffset() / -60; // 分から時差（時単位）に変換

    const formattedDate = `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    const timezoneAdjustedDate = new Date(date.getTime() + (timezoneOffset * 60 * 60 * 1000));
    const adjustedHours = String(timezoneAdjustedDate.getHours()).padStart(2, '0');
    const adjustedMinutes = String(timezoneAdjustedDate.getMinutes()).padStart(2, '0');
    const adjustedSeconds = String(timezoneAdjustedDate.getSeconds()).padStart(2, '0');

    return `${formattedDate} (UTC${timezoneOffset >= 0 ? '+' : ''}${timezoneOffset}:${adjustedHours}:${adjustedMinutes}:${adjustedSeconds})`;
  };

  static getFormattedDateYYYYMMDDWithTimezone(utc: string) {
    const date = new Date(utc);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}/${month}/${day}`
    return formattedDate;
  };

  static getFormattedDateFromUTCString(utc: string) {
    const date = new Date(utc);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  // 同一フォーマットの日付文字列を比較する。
  // 第一引数が過去の場合、true。それ以外はfalse
  static isPastRecommendFoodDateString(firstDateString: string, secondDateString: string) {
    // 単純に文字列比較を行う
    return (firstDateString < secondDateString);
  }
}